<div [formGroup]="entityForm" *ngIf="form && entity">
  <wm-de-label *ngIf="entity.showLabel" [entity]="entity" [for]="entity.templateCode"></wm-de-label>
  <div>
    <div class="card">
      <div class="card-body">
        <div>
          @if(!templateForPermitForm){
          <div [formGroup]="entityForm">
            <!-- // Stack the columns on mobile by making one full-width and the other half-width -->
            <div class="row">
              <div class="col-12 mb-2">
                Select Contractor
              </div>
            </div>
            <div class="row ml-2">
              <div class="col-12 col-sm-3 col-md-4 col-lg-2 col-xl-3" >
                <div [class.text-muted]="isMyselfOptionDisabled">
                  <input type="radio" value="myself" #myself (change)="selectMyself()" [checked]="isContractorValue('myself')" formControlName="contractorValue" [disabled]="isMyselfOptionDisabled"/>
                  Myself
                  <app-loader *ngIf="entity.inputData.selectedRegistrationId && !contractor && isContractorValue('myself')"></app-loader>
                  <wm-select-contractor-details [contractor]="contractor" (cleared)="clearSelection()" [showClear]="false" *ngIf="isContractorValue('myself')"></wm-select-contractor-details>
                </div>
              </div>
              <div class="col-12 col-sm-9 col-md-8 col-lg-10 col-xl-9" [ngClass]="{
                  disabledInActiveDiv: !isContractorValue('myself')
                }">
                <div *ngIf="(!availableRegistrations || availableRegistrations.length == 0)">
                    <wm-modal-confirm (opened)="openRegister()" (accepted)="registerForContractor(registerContractorTypeId)"
                    *ngIf="contractorTypeDetails && entity.allowRegisterRenewOption"
                    [showButtonText]="true"
                    buttonText="Register"
                    [showButton]="true"
                    [buttonStyle]="ButtonStyle.Link"
                    title="Register Contractor"
                    commandText="Register">
                    <div class="form-group" *ngIf="entity.contractorTypeIds.length > 1">
                      <div class="control-label">Contractor Type</div>
                      <select class="form-control" formControlName="registerContractorTypeId" [(ngModel)]="registerContractorTypeId">
                        <option *ngFor="let ct of entity.contractorTypeIds" [value]="ct">
                          {{contractorTypeDetails[ct].name}}</option>
                      </select>
                    </div>
                    <div *ngIf="registerContractorTypeId">
                      <p>This will start the registration process for a "{{contractorTypeDetails[registerContractorTypeId].name}}".
                        You will be taken away from this application to complete that application.</p>
                      <p>You will need to return back to this application once you complete your contractor
                        registration process to continue this application.</p>
                    </div>
                  </wm-modal-confirm>
                  <p *ngIf="!entity.allowRegisterRenewOption">You will need to register as {{ (entity.contractorTypeIds.length == 1 ? 'a ' : 'one of the following contractors: ') + getTypeNameList }}.</p>
                </div>
                <ng-container *ngIf="((availableRegistrations?.length || 0) > 0)">
                  <div class="row" *ngFor="let r of availableRegistrations">
                    <div class="col">
                      <div class="row">
                        <div class="col">
                          <input type="radio" [value]="r.registrationId" *ngIf="(availableRegistrations?.length || 0) > 1"  formControlName="selectReg" (change)="selectRegistration(r)"/>
                          <span class="pl-2" *ngIf="entity.contractorTypeIds.length > 1">{{ r.contractorTypeName }} -
                          </span>{{r.businessName}}
                          <wm-modal-confirm (accepted)="renewRegistration(r.registrationId)"
                            *ngIf="r.status == RegistrationStatus.Expired && contractorTypeDetails && entity.allowRegisterRenewOption"
                            [showButtonText]="true"
                            buttonText="Renew"
                            [showButton]="true"
                            [buttonStyle]="ButtonStyle.Link"
                            title="Renew Contractor"
                            commandText="Renew">
                            <div *ngIf="r?.contractorTypeId">
                              <p>This will start the renewal process for a "{{contractorTypeDetails[r.contractorTypeId].name}}".
                                You will be taken away from this application to complete that application.</p>
                              <p>You will need to return back to this application once you complete your contractor
                                renewal process to continue this application.</p>
                            </div>
                          </wm-modal-confirm>
                          <span *ngIf="r.status == RegistrationStatus.Inactive"> (Inactive) </span>
                          <a (click)="updateRequirements(r)"
                            style="cursor: pointer;text-decoration: none;color:#009688;background-color: transparent"
                            *ngIf="r.status == RegistrationStatus.Inactive && entity.allowRegisterRenewOption">Update</a>
                        </div>
                      </div>
                      <div class="row" *ngIf="r.updatingRequirements && r.requirementCustomFields">
                        <div class="col">
                          <div class="card mt-3">
                            <div class="card-body">
                              <h1 class="card-title">Contractor Requirements</h1>
                              <app-loader *ngIf="r.savingRequirements"></app-loader>
                              <wm-contractor-custom-field-list [customFields]="r.requirementCustomFields" [form]="form"
                                #customFields></wm-contractor-custom-field-list>
                              <div class="row">
                                <div class="col">
                                  <div class="float-end">
                                    <button class="btn btn-raised btn-default mr-2"
                                      (click)="cancelRegistrationUpdate(r)">Cancel</button>
                                    <button class="btn btn-raised btn-primary"
                                      (click)="saveRegistrationUpdate(r)" [disabled]="r.savingRequirements">Save</button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </ng-container>
              </div>
            </div>
            <hr />
            <div class="row ml-2">
              <div class="col-12 col-sm-3 col-md-4 col-lg-2 col-xl-3">
                <input type="radio" value="otherContractor"
                  (change)="otherContractorSelected($event)" [checked]="isContractorValue('otherContractor')" formControlName="contractorValue"  />
                Other Contractor
                <app-loader *ngIf="entity.inputData.selectedRegistrationId && !contractor && isContractorValue('otherContractor')"></app-loader>
                <wm-select-contractor-details [contractor]="contractor" (cleared)="clearSelection()" *ngIf="isContractorValue('otherContractor')"></wm-select-contractor-details>
              </div>
              <div class="col-12 col-sm-9 col-md-8 col-lg-10 col-xl-9" *ngIf="isContractorValue('otherContractor')" [ngClass]="{
                  disabledInActiveDiv: !isContractorValue('otherContractor')
                }">
                <div>
                  <div class="form-group">
                    <label for="search">Search</label>
                    <input type="text" class="form-control" name="search" id="search" placeholder="Search..."
                      [(ngModel)]="searchText" (ngModelChange)="searchTextChanged.next($event)"
                      [ngModelOptions]="{ standalone: true }" />
                  </div>

                  <ul class="list-group">
                    <span class="list-group-item" *ngIf="searching">Searching...</span>
                    <button type="button" class="list-group-item list-group-item-action" style="cursor: pointer;"
                      [disabled]="!entity.canEditContractor" [ngClass]="{
                      active:
                        registration.id ===
                        entity.inputData?.selectedRegistrationId
                    }" (click)="selectItem(registration.id)" *ngFor="let registration of registrations">
                      {{ registration.contractor.businessName }} ({{ registration.type.name }})
                    </button>
                  </ul>

                  <nav aria-label="Page navigation" *ngIf="pagination.pageCount > 1">
                    <ul class="pagination">
                      <li class="page-item" [ngClass]="{ disabled: pagination.pageNumber === 0 }">
                        <a class="page-link" href="javascript:void(0)" (click)="setPage(pagination.pageNumber - 1)">
                          Previous
                        </a>
                      </li>
                      <li class="page-item" [ngClass]="{ active: page - 1 === pagination.pageNumber }"
                        *ngFor="let page of pages">
                        <a class="page-link" href="javascript:void(0)" (click)="setPage(page - 1)">
                          {{ page }}
                        </a>
                      </li>
                      <li class="page-item" [ngClass]="{
                        disabled: pagination.pageNumber === pagination.pageCount - 1
                      }">
                        <a class="page-link" href="javascript:void(0)" (click)="setPage(pagination.pageNumber + 1)">
                          Next
                        </a>
                      </li>
                    </ul>
                  </nav>

                  <div class="switch" *ngIf="entity.allowNotListedOption" (change)="notInListChanged($event)">
                    <label>
                      <input type="checkbox" formControlName="notInList" [(ngModel)]="entity.inputData.notInList" />
                      Contractor Not Listed
                    </label>
                  </div>
                </div>
                <wm-modal-confirm (opened)="openRegister()" (accepted)="registerForContractor(registerContractorTypeId)"
                    *ngIf="contractorTypeDetails && canApplyOnBehalfOf && entity.allowRegisterRenewOption"
                    [showButtonText]="true"
                    buttonText="Register"
                    [showButton]="true"
                    [buttonStyle]="ButtonStyle.Link"
                    title="Register Contractor"
                    commandText="Register">
                    <div class="form-group" *ngIf="entity.contractorTypeIds.length > 1">
                      <div class="control-label">Contractor Type</div>
                      <select class="form-control" formControlName="registerContractorTypeId" [(ngModel)]="registerContractorTypeId">
                        <option *ngFor="let ct of entity.contractorTypeIds" [value]="ct">
                          {{contractorTypeDetails[ct].name}}</option>
                      </select>
                    </div>
                    <div *ngIf="registerContractorTypeId">
                      <p>This will start the registration process for a "{{contractorTypeDetails[registerContractorTypeId].name}}".
                        You will be taken away from this application to complete that application.</p>
                      <p>You will need to return back to this application once you complete your contractor
                        registration process to continue this application.</p>
                    </div>
                  </wm-modal-confirm>
              </div>
            </div>
          </div>
        }
        @else{
    <div [formGroup]="entityForm" *ngIf="form && entity" class="column-content">
  
  <!-- <wm-de-label
    *ngIf="entity.showLabel"
    [entity]="entity"
    [for]="entity.templateCode"
  ></wm-de-label> -->
 
  <div class="column-content" [formGroup]="entityForm">
     <div class="row">
              <wm-common-text

                [data]="{ text: 'Select Contractor' }"
              ></wm-common-text>
            </div>
 <div class="mb-3">
  <mat-radio-group
    class="common-radio-group column"
    formControlName="contractorValue"
    (change)="onContractorTypeChange($event.value)"
  >
    <div class="row-content">
      <mat-radio-button value="myself" [disabled]="isMyselfOptionDisabled">
        <div class="radio-label flex" style="align-items:center; gap:8px;">
          <wm-common-text [data]="{ text: 'Myself' }"></wm-common-text>
        </div>
      </mat-radio-button>
      <wm-common-button
      class="register-btn"
        *ngIf="contractorTypeDetails && entity.allowRegisterRenewOption && (!availableRegistrations || availableRegistrations.length == 0)"
        [data]="{ text: 'Register', onClick: openRegisterModal.bind(this) }"
      ></wm-common-button>
    </div>

    <div class="row-content">
      <mat-radio-button value="otherContractor">
        <wm-common-text [data]="{ text: 'Other Contractor' }"></wm-common-text>
      </mat-radio-button>
    </div>
  </mat-radio-group>
</div>

    <ng-container *ngIf="isContractorValue('myself')">
      <div class="column-content pl-3"> <app-loader
          *ngIf="entity.inputData.selectedRegistrationId && !contractor"
        ></app-loader>

        <wm-select-contractor-details
          [contractor]="contractor"
          (cleared)="clearSelection()"
          [showClear]="false"
        ></wm-select-contractor-details>
        <div [ngClass]="{ disabledInActiveDiv: !isContractorValue('myself') }">
          
        

         

          <wm-common-text
            *ngIf="!entity.allowRegisterRenewOption && (!availableRegistrations || availableRegistrations.length == 0)"
            [data]="{
              text: 'You will need to register as ' + (entity.contractorTypeIds.length === 1 ? 'a ' : 'one of the following contractors: ') + getTypeNameList
            }"
          ></wm-common-text>
        </div>

        <ng-container *ngIf="(availableRegistrations?.length || 0) > 0">
          <div class="row" *ngFor="let r of availableRegistrations">
            <div class="col">
              <div class="row">
                <div class="col">
                  <input
                    type="radio"
                    [value]="r.registrationId"
                    *ngIf="(availableRegistrations?.length || 0) > 1"
                    formControlName="selectReg"
                    (change)="selectRegistration(r)"
                  />
                  <wm-common-text
                    class="pl-2"
                    *ngIf="entity.contractorTypeIds.length > 1"
                    [data]="{text: r.contractorTypeName + ' - ' + r.businessName }"
                  ></wm-common-text>

            
                  <wm-common-button
                    class="register-btn"
                    *ngIf="r.status == RegistrationStatus.Expired && contractorTypeDetails && entity.allowRegisterRenewOption"
                    [data]="{ text: 'Renew', onClick: openRenewModal.bind(this, r) }"
                  ></wm-common-button>

                  <wm-common-confirmation-modal
                    #renewModal
                    [data]="renewModalData"
                    (onYesClick)="confirmRenew()"
                    (onNoClick)="closeRenewModal()"
                  >
                    <div *ngIf="selectedRenewRegistration?.contractorTypeId">
                      <wm-common-text
                        [data]="{text: 'This will start the renewal process for a ' + contractorTypeDetails[selectedRenewRegistration.contractorTypeId].name + '. You will be taken away from this application to complete that application.'}"
                      ></wm-common-text>
                      <wm-common-text
                        [data]="{text: 'You will need to return to this application once you complete your contractor renewal process to continue this application.'}"
                      ></wm-common-text>
                    </div>
                  </wm-common-confirmation-modal>

                  <wm-common-text
                    *ngIf="r.status == RegistrationStatus.Inactive"
                    [data]="{ text: 'Inactive' }"
                  ></wm-common-text>
                  <wm-common-button
                    class="register-btn"
                    *ngIf="r.status == RegistrationStatus.Inactive && entity.allowRegisterRenewOption"
                    [data]="{ text: 'Update', onClick: updateRequirements.bind(this, r) }"
                  ></wm-common-button>
                </div>
              </div>

              <div class="row" *ngIf="r.updatingRequirements && r.requirementCustomFields">
                <div class="col">
                  <div class="card mt-3">
                    <div class="card-body">
                      <wm-common-text class="card-title" [data]="{ text: 'Contractor Requirements' }"></wm-common-text>
                      <app-loader *ngIf="r.savingRequirements"></app-loader>
                      <wm-contractor-custom-field-list
                        [customFields]="r.requirementCustomFields"
                        [form]="form"
                        #customFields
                      ></wm-contractor-custom-field-list>
                      <div class="row">
                        <div class="col">
                          <div class="float-end">
                            <wm-common-button
                              class="cancel-btn"
                              [data]="{ text: 'Cancel', onClick: cancelRegistrationUpdate.bind(this, r) }"
                            ></wm-common-button>
                            <wm-common-button
                              class="register-btn"
                              [data]="{ text: 'Save', disabled: r.savingRequirements, onClick: saveRegistrationUpdate.bind(this, r) }"
                            ></wm-common-button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </ng-container>

      </div>
    </ng-container>

    <ng-container *ngIf="isContractorValue('otherContractor')">
      <div class="column-content pl-3"> <div [ngClass]="{ disabledInActiveDiv: !isContractorValue('otherContractor') }">
          
          <div class="form-group">
            <wm-common-textfield
              *ngIf="isContractorValue('otherContractor')"
              [data]="searchTextfieldData" (valueChange)="onSearchTextChange($event)"
            ></wm-common-textfield>

            <ul class="list">
              <wm-common-text *ngIf="searching" [data]="{ text: 'Searching...' }"></wm-common-text>
              
              <wm-common-button
                *ngFor="let registration of registrations"
                [data]="{
                   text: registration.contractor.businessName + ' ' + registration.type.name,
                   disabled: !entity.canEditContractor,
                   onClick: selectItem.bind(this, registration.id)
                }"
                [ngClass]="{ active: registration.id === entity.inputData?.selectedRegistrationId }"
                class="list-button"
              ></wm-common-button>
            </ul>
          </div>

          <app-loader
            *ngIf="entity.inputData.selectedRegistrationId && !contractor"
          ></app-loader>
          
          <wm-select-contractor-details
            class="col-12 col-sm-9 col-md-8 col-lg-10 col-xl-9 flex"
            [contractor]="contractor"
            (cleared)="clearSelection()"
          ></wm-select-contractor-details>

          <nav aria-label="Page navigation" *ngIf="pagination.pageCount > 1">
            <ul class="pagination">
              <li class="page-item" [ngClass]="{ disabled: pagination.pageNumber === 0 }">
                <a class="button-page" href="javascript:void(0)" (click)="setPage(pagination.pageNumber - 1)">Previous</a>
              </li>
              <li class="page-item" [ngClass]="{ active: page - 1 === pagination.pageNumber }" *ngFor="let page of pages">
                <a class="button-page" href="javascript:void(0)" (click)="setPage(page - 1)">{{ page }}</a>
              </li>
              <li class="page-item" [ngClass]="{ disabled: pagination.pageNumber === pagination.pageCount - 1 }">
                <a class="button-page" href="javascript:void(0)" (click)="setPage(pagination.pageNumber + 1)">Next</a>
              </li>
            </ul>
          </nav>

          <div class="toggle-class" *ngIf="entity.allowNotListedOption" (change)="notInListChanged($event)">
            <label style="padding-left: 0px; display: flex; gap: 12px;" >
             

        <input type="checkbox" formControlName="notInList" class="native-toggle" [(ngModel)]="entity.inputData.notInList" />
      <wm-common-text [data]="{ text: 'Contractor Not Listed' }"></wm-common-text>
            </label>
          </div>

          <wm-common-button
          class="register-btn"
            *ngIf="contractorTypeDetails && canApplyOnBehalfOf && entity.allowRegisterRenewOption"
            [data]="{ text: 'Register', onClick: openRegisterModal.bind(this)}"
          ></wm-common-button>

          

          </div>
      </div>
    </ng-container>

 <wm-common-confirmation-modal
            #registerModal
            [data]="registerModalData"
            (onYesClick)="registerForContractor(registerContractorTypeId)"
            (onNoClick)="closeRegisterModal()"
          >
            <div class="form-group" *ngIf="entity.contractorTypeIds.length > 1">
              <wm-common-text [data]="{ text: 'Contractor Type' }"></wm-common-text>
              <!-- Replaced native <select> with wm-common-dropdown for templateForPermitForm=true -->
              <wm-common-dropdown
                formControlName="registerContractorTypeId"
                [data]="{
                  placeholder: 'Select Contractor Type',
                  options: contractorTypeDropdownOptions,
                  selectedValue: registerContractorTypeId
                }"
                (valueChange)="onRegisterContractorTypeChange($event)"
              ></wm-common-dropdown>
            </div>

            <div *ngIf="registerContractorTypeId">
              <wm-common-text
                [data]="{text: 'This will start the registration process for a ' + contractorTypeDetails[registerContractorTypeId].name + '. You will be taken away from this application to complete that application.'}"
              ></wm-common-text>
              <wm-common-text
                [data]="{text: 'You will need to return to this application after completing the contractor registration process to continue.'}"
              ></wm-common-text>
            </div>
          </wm-common-confirmation-modal>
  </div>
</div>
    }
 
        </div>
      </div>
    </div>
  </div>
</div>